import { render, staticRenderFns } from "./invalidatedBill.vue?vue&type=template&id=498add95&scoped=true&"
import script from "./invalidatedBill.vue?vue&type=script&lang=js&"
export * from "./invalidatedBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498add95",
  null
  
)

export default component.exports